module.exports = __webpack_public_path__ + "static/media/fan_bg.a3abde96.png";